import {createSvgIcon} from '../create-svg-icon';

export const NorthIcon = createSvgIcon(
  <path d="m5 9 1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z" />
, 'NorthOutlined');
